// Permission constants matching backend Permissions.cs
export const Permissions = {
  // TeamMembers permissions
  TeamMembersRead: 'team-members.read',
  TeamMembersReadOwn: 'team-members.read.own',
  TeamMembersAgendaRead: 'team-members.agenda.read',
  TeamMembersAgendaReadOwn: 'team-members.agenda.read.own',
  TeamMembersCreate: 'team-members.create',
  TeamMembersUpdate: 'team-members.update',
  TeamMembersUpdateOwn: 'team-members.update.own',

  // Stores permissions
  StoresCreate: 'stores.create',
  StoresRead: 'stores.read',
  StoresUpdate: 'stores.update',
  StoresImagesAdd: 'stores.images.create',
  StoresImagesDelete: 'stores.images.delete',
  StoresRolesRead: 'stores.roles.read',
  StoresRolesCreate: 'stores.roles.create',
  StoresRolesUpdate: 'stores.roles.update',
  StoresRolesDelete: 'stores.roles.delete',

  // Services permissions
  ServicesCreate: 'services.create',
  ServicesUpdate: 'services.update',
  ServicesDelete: 'services.delete',

  // Memberships permissions
  MembershipsRead: 'memberships.read',
  MembershipsWrite: 'memberships.write',
  MembershipsPaymentUpdate: 'memberships.payment.update',

  // Service packages permissions
  ServicePackagesRead: 'service-packages.read',
  ServicePackagesWrite: 'service-packages.write',
  ServicePackagesSell: 'service-packages.sell',

  // Consent forms permissions
  ConsentFormsRead: 'consent-forms.read',
  ConsentFormsWrite: 'consent-forms.write',

  // Customers permissions
  CustomersRead: 'customers.read',
  CustomersCreate: 'customers.create',
  CustomersUpdate: 'customers.update',

  // Appointments permissions
  AppointmentsCreate: 'appointments.create',
  AppointmentsUpdate: 'appointments.update',
  AppointmentsUpdateOwn: 'appointments.update.own',
  AppointmentsDelete: 'appointments.delete',
  AppointmentsPaymentUpdate: 'appointments.payment.update',
  AppointmentsDiscount: 'appointments.discount',
  AppointmentsPriceUpdate: 'appointments.price.update',

  // Products permissions
  ProductsRead: 'products.read',
  ProductsCreate: 'products.create',
  ProductsUpdate: 'products.update',
  ProductsDelete: 'products.delete',
  ProductsSettingsUpdate: 'products.settings.update',
  ProductSalesRead: 'product-sales.read',
  ProductSalesCreate: 'product-sales.create',
  ProductSalesVoid: 'product-sales.void',
  ProductSalesAssignSeller: 'product-sales.seller.assign',
  ProductSalesEditCustomerLines: 'product-sales.customer-lines.edit',

  StockRead: 'stock.read',
  StockPurchasesCreate: 'stock.purchases.create',
  StockPurchasesVoid: 'stock.purchases.void',
  StockAdjust: 'stock.adjust',
  StockCostsRead: 'stock.costs.read',
  SuppliersManage: 'suppliers.manage',

  ExpensesRead: 'expenses.read',
  ExpensesWrite: 'expenses.write',

  // Employee payments permissions
  EmployeePaymentsSettingsUpdate: 'employee-payments.settings.update',
  EmployeePaymentsRead: 'employee-payments.read',
  EmployeePaymentsReadOwn: 'employee-payments.read.own',

  // Notification settings permissions
  StoresNotificationSettingsUpdate: 'stores.notification-settings.update',

  Chat: 'chat',
};

export default Permissions;

